import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Divider, Button, Form } from "semantic-ui-react";
import axios from "axios";

const PopupHomeAdd = () => {
    const navigate = useNavigate()
    const [information, setInformation] = useState('')
    const [image, setImage] = useState([])
    const [url, setUrl] = useState('')
    const [active, setActive] = useState('N')

    const handleImageChange = (e) => {
        let file = e.target.files
        setImage(file[0])
    }

    const handleCheckbox = (checked) => {
        setActive(checked ? 'Y' : 'N')
    }

    const handleSubmit = () => {
        const param = new FormData()
        param.append("information", information)
        param.append("image", image)
        param.append("url", url)
        param.append("is_active", active)
        
        //alert(information + " , " + image + " , " + url+ " , " + active)
        axios({
            method:"POST",
            url:`${global.SRV}api_rudrunner_cms/controler/popup.php/?index=2`,
            headers:{'Content-Type': 'text/plain'},
            data:param
        })
        .then (res => { console.log(res.data)
            if (res.data.state === 200){
                navigate('/popup_home')
            }
        })
    }

    return (
        <Container fluid>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0">Add Popup</div>
                <div className="text-muted">Adding new Popup</div>
            </Row>
            <Divider />
            <Row className="d-flex justify-content-center mb-3 mt-3">
                <Col xl={6} lg={10} md={12} sm={12} className="mb-3">
                    <Form widths="equal" onSubmit={handleSubmit}>
                        <Form.Field>
                            <Form.Input type="text" label="Information" onChange={(e,{value}) => setInformation(value)}/>
                        </Form.Field>
                        <Form.Field>
                            <Form.Input type="text" label="Url CTA" onChange={(e,{value}) => setUrl(value)}/>
                        </Form.Field>
                        <Form.Input
                            label="Image"
                            type="file"
                            icon="image"
                            className="mb-0 mt-3"
                            required
                            onChange={(e) => handleImageChange(e)}
                        />
                        <small className="text-muted">Images must be in *.png format and file size no more than 500kb</small>
                        <Form.Checkbox
                            className="mt-4"
                            inline
                            label="Enable Popup"
                            checked={active === 'Y'}
                            onChange={(e, data) => handleCheckbox(data.checked)}
                        />
                        <Form.Field className="mt-4">
                            <Form.Button content="Save" color="facebook"/>
                        </Form.Field>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default PopupHomeAdd